import Vue from 'vue'

import XEUtils from 'xe-utils'
Vue.prototype.$XEUtils = XEUtils

import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'


//自定义全局的格式化处理函数
//通过	formatter="formatDate" 或	:formatter="['formatDate', 'yyyy-MM-dd']"  使用

VXETable.formats.mixin({	
	// 格式化真假
	formatTF(cellValue) {
		return cellValue === true ? '是' : '否'
	},
	// 格式化下拉选项
	formatSelect(cellValue, list) {
		const item = list.find(item => item.value === cellValue)
		return item ? item.label : ''
	},
	// 格式化日期，默认 yyyy-MM-dd HH:mm:ss
	formatDate(cellValue, format) {
		return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
	},
	// 格式金额，默认2位数
	formatAmount(cellValue, digits) {
		return XEUtils.commafy(cellValue, {
			digits: digits || 2
		})
	},
	// 格式化银行卡，默认每4位隔开
	formatBankcard(cellValue) {
		return XEUtils.commafy(cellValue, {
			spaceNumber: 4,
			separator: ' '
		})
	},
	// 四舍五入,默认两位数
	// formatter="formatFixedNumber"
	// :formatter="['formatFixedNumber', '1']" 
	formatFixedNumber(cellValue, digits) {
		return XEUtils.toNumber(cellValue).toFixed(digits || 2)
	},
	// 截取小数,默认两位数
	formatCutNumber(cellValue, digits) {
		return XEUtils.toFixedString(cellValue, digits || 2)
	}
})

Vue.use(VXETable)
VXETable.use(VXETablePluginElement)